import { useQuery } from "react-query";

import { fetchSubscriptionItems } from "./subscriptionItems.fetcher";
import { subscriptionItemsKey } from "./subscriptionItems.constants";

export function useSubscriptionItemsQuery() {
  return useQuery({ queryKey: subscriptionItemsKey, queryFn: fetchSubscriptionItems, staleTime: 2 * 60 * 1000 });
}
